import React from "react"
import {createRoot} from "react-dom/client"
import {LongTickingClock} from "../components/ticking_clock"

function initTrialBanner(target) {
  return createRoot(target).render(
    <LongTickingClock
      timeLeft={48 * 60 * 60 * 1000 - timeSinceConfirmed()}
    />
  )
}

function timeSinceConfirmed(user = window.gon.currentUser) {
  return Date.now() - user.confirmedAt * 1000
}

export default initTrialBanner
